import React from 'react';

import { getWebMdPage, openExternalUrl } from 'src/utils/utils';
import { HEALTH_GOALS_PAGE } from 'src/utils/constants';
import { useStore } from 'src/hooks/useStore';
import EmptyStateMessage from 'src/components/molecules/empty-state-message/EmptyStateMessage';
import EnhancedButton from 'src/components/atoms/enhanced-button/EnhancedButton';
import EnhancedExternalLink from 'src/components/atoms/enhanced-external-link/EnhancedExternalLink';

const healthGoalsUrl = getWebMdPage(HEALTH_GOALS_PAGE);
const HealthGoalsInterstitial: React.FC = () => {
  const { healthGoalsStore } = useStore();
  const { activeHealthGoals, endedHealthGoals } = healthGoalsStore.healthGoal || {};
  if (activeHealthGoals?.length) {
    const actionElement = (
      <EnhancedButton onClick={() => openExternalUrl(healthGoalsUrl)} isExternal>
        Pin Goals
      </EnhancedButton>
    );
    return (
      <EmptyStateMessage
        message="You do not have any Health Goals pinned."
        actionElement={actionElement}
      />
    );
  }

  if (endedHealthGoals?.length) {
    const endedHealthGoalsUrl = `${healthGoalsUrl}?tab=Ended`;
    const actionElement = (
      <EnhancedExternalLink href={endedHealthGoalsUrl}>
        Review Ended Goals
      </EnhancedExternalLink>
    );
    return (
      <EmptyStateMessage
        message="Some goals have ended but can still be reviewed before they are removed."
        actionElement={actionElement}
      />
    );
  }

  const completedHealthGoalsUrl = `${healthGoalsUrl}?tab=Completed`;
  const actionElement = (
    <EnhancedExternalLink href={completedHealthGoalsUrl}>
      View Completed Goals
    </EnhancedExternalLink>
  );
  return (
    <EmptyStateMessage
      message="You do not have any Active goals."
      actionElement={actionElement}
    />
  );
};

export default HealthGoalsInterstitial;
